"use client";

import { usePathname } from "next/navigation";
import { useEffect, useState } from "react";

import { TutorialModal } from "@/components/tutorial/TutorialModal";
import { hasTutorialBeenSeen, markTutorialAsSeen } from "@/lib/storage";

export function TutorialContainer() {
  const pathname = usePathname();
  const [isOpen, setIsOpen] = useState(false);

  const isListsPage = pathname === "/lists" || pathname.endsWith("/lists");

  useEffect(() => {
    if (!isListsPage || hasTutorialBeenSeen()) return;

    const timer = setTimeout(() => {
      setIsOpen(true);
    }, 500);
    return () => clearTimeout(timer);
  }, [isListsPage]);

  useEffect(() => {
    const handler = () => setIsOpen(true);
    window.addEventListener("open-tutorial", handler);
    return () => window.removeEventListener("open-tutorial", handler);
  }, []);

  return (
    <TutorialModal
      isOpen={isOpen}
      onClose={() => {
        setIsOpen(false);
        markTutorialAsSeen();
      }}
    />
  );
}
